<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Pro',

    metaInfo: { title: 'Mentions Legales' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'mentions-legales',
        'info',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'mentions-legales',
      },
    },
  }
</script>
